import { useQuery } from '@tanstack/react-query';
import { projectApiConnect } from '../lib/api/projectApi.connect';
/**
 * Fetch a proposal project by ID with type safety
 * Transforms the generic project response into a proposal project
 */ export function useProposalProject(projectId) {
    return useQuery({
        queryKey: [
            'proposal-project',
            projectId ?? null
        ],
        queryFn: async ()=>{
            if (!projectId) throw new Error('Missing projectId');
            const response = await projectApiConnect.getProject(projectId);
            // Validate that this is a proposal project
            if (response.project.type !== 'proposal') {
                throw new Error('Project is not a proposal project');
            }
            return response;
        },
        enabled: !!projectId,
        staleTime: 30000
    });
}
